@for (evaluation of evaluationsListFilter | byWord:searchEvaluation:filterTypes | afOrderBy:filterOrder:order; track evaluation.evaluationId) {
  @if (view !== 'groupClients' || (view === 'groupClients' && evaluation.clientId === client?.clientId)) {
    <div class="common-table-body__row">
      <div
        class="common-table-body__inner-row"
        [ngClass]="view === 'deleted' ? 'w-[calc(100%-30px)]' : 'w-[calc(100%-62px)]'"
        (click)="clickRow(evaluation, $event)">
        <div class="common-table-cell__container w-[25%]">
          @if (view !== 'groupClients') {
            <span-tooltip
              class="common-table-cell__standard-text-label"
              [text]="evaluation.clientName">
            </span-tooltip>
          }
        </div>
        <div class="common-table-cell__container w-[calc(25%-30px)]">
          <span-tooltip
            class="common-table-cell__standard-text-label"
            [text]="evaluation.name">
          </span-tooltip>
        </div>
        <div class="common-table-cell__container w-[30px]">
          @if (evaluation.operationLocked || evaluation.operationNotSupported) {
            <i
              class="common-icon__md-red"
              [ngClass]="evaluation.operationLocked ? 'lf-icon-alert' : 'lf-icon-close-round'"
              pTooltip="{{(evaluation.operationLocked ? 'common.locked' : 'evaluation-header.not-supported') | afTranslate}}"
              tooltipPosition="bottom">
            </i>
          }
        </div>
        <div class="common-table-cell__container w-[25%]">
          @if (evaluation.result) {
            <div class="common-tag__container-tag">
              <div
                [class]="'common-tag__state-task common-tag__state-task--' + (evaluation.colorResult | colors)">
                <span-tooltip
                  class="common-tag__state-task-text"
                  [text]="evaluation.result">
                </span-tooltip>
              </div>
            </div>
          }
        </div>
        <div class="common-table-cell__container w-[25%]">
          <span-tooltip
            class="common-table-cell__standard-text-label"
            [text]="evaluation.modified | convertDate: 'without-time'">
          </span-tooltip>
        </div>
      </div>
      @if(evaluation.canManage && evaluation.type !== 'client'){
        <div class="common-table-cell__container-actions"
          [ngClass]="view === 'deleted'?'w-[30px]':'w-[62px]'">
          @if (view !== 'deleted') {
            <button class="common-button__icon-md-noborder"
              pTooltip="{{'expanded-menu.rename' | afTranslate}}"
              tooltipPosition="bottom"
              (click)="emitEvent('rename', evaluation)">
              <i class="lf-icon-rename common-icon__md"></i>
            </button>
          }
          <button class="common-button__icon-md-noborder"
            pTooltip="{{'common.remove' | afTranslate}}"
            tooltipPosition="bottom"
            (click)="emitEvent('deleteEvaluation', evaluation)">
            <i class="lf-icon-trash common-icon__md"></i>
          </button>
        </div>
      }
    </div>
  }
}
